import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import { UserService, LoaderService, DataService, AuthService } from '../app/shared/services';
import { MessageBoxService } from './shared/services/message-box.service';
import { interval, Subscription } from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmInactiveLogoutComponent } from './shared/components/confirm-inactive-logout/confirm-inactive-logout.component';
import { VersionService } from './shared/services/version.service';
import { concatMap, filter, switchMap, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  timer: Subscription;
  appVersion: string;
  token: string ="";
  count: number = 60;
  remainingCount: number;
  counterSubscription: Subscription;
  originalTitle = document.title;
  tokenExpirationTime: number = 60;
  constructor(
    private userService: UserService,
    private router: Router,
    private actRounter: ActivatedRoute,
    private loaderService: LoaderService,
    private dataService: DataService,
    private authService: AuthService,
    private _msgService: MessageBoxService,
    private versionService: VersionService,
    public dialog: MatDialog) {
  }



  ngOnInit() {  
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        switchMap(() => this.actRounter.queryParamMap),
        take(1)
      )
      .subscribe((params) => {

        const tokenKey = Array.from(params.keys).find(k => k.toLowerCase() === 'token');
        this.token = tokenKey ? params.get(tokenKey) : null;

        if (!this.token) {
          this.userService.checkVaccineContext();
        }
      });

    if (this.dataService.vaccineContext.getToken() != null) {
      if (this.userService.getTokenRemainingTime() <= 0) {

        this.showSessionExpirationMessage();

      } else {
        this.watchUserLastTransaction();
      }
    }

    this.dataService.vaccineContext.contextLoaded.subscribe(_ => {
      this.watchUserLastTransaction();
    });

  }

  private showSessionExpirationMessage(message: string = 'Your session expired. Please login to continue') {
    this._msgService.error({
      title: 'Session Expired',
      message: message
    }).subscribe(_ => {

      if (this.timer) {
        this.timer.unsubscribe();
      }
      this.userService.logOff();
    });
  }

  ngAfterViewInit() {

    this.router.events.subscribe((event) => {

      if (event instanceof NavigationStart) {
        this.loaderService.showLoader();
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.loaderService.hideLoader();
      }
    });

  }
  ngOnDestroy() {
    if (this.timer) {
      this.timer.unsubscribe(); // Stop the timer when the component is destroyed
    }
  }

  watchUserLastTransaction() {    
    if (this.timer == null || this.timer.closed) {
      this.timer = interval(60000*5).subscribe(_ => {
        this.userService.getLastTranTime().subscribe((date: { lastTranTime: string }) => {
          //get token remaining time
          const timeToShowDialog = this.userService.getTokenExpiryInMinutes();          
          const timeout = this.userService.getTokenRemainingTime();
          const diffInMs = Date.now() - new Date(date.lastTranTime).getTime();
          const lastMin = Math.floor(diffInMs/60000) +1;
          if(lastMin <= timeToShowDialog && timeout >= 0 && timeout < 1000*60*5){
            this.refreshToken(false);
          }
          if (lastMin >= timeToShowDialog) {
            this.startCountdown();
            const dialogRef = this.dialog.open(ConfirmInactiveLogoutComponent, {
              disableClose: true,
              data: null
            });

            if (this.timer) {
              this.timer.unsubscribe(); // Stop the timer when the component is destroyed
            }

            dialogRef.afterClosed().subscribe(result => {
              if (this.counterSubscription) {
                this.counterSubscription.unsubscribe();
              }
              document.title = this.originalTitle;
              if (result == 'continue') {
                const remainingTime = this.userService.getTokenRemainingTime() + (5 * 60 * 1000);
                if (remainingTime <= 0) {
                  this.showSessionExpirationMessage('Your session already expired. Please login to continue');
                } else {
                  this.refreshToken(true);
                  this.watchUserLastTransaction();
                }

              } else if (result = 'logoff') {
                if (this.timer) {
                  this.timer.unsubscribe();
                }
                this.userService.logOff();
              }

            });


          }

        });


      });

    }
  }

  private refreshToken(recordTransaction: boolean) {
    this.userService.refreshToken(recordTransaction).subscribe(
      _ => {},
      err => {
        console.error('Error refreshing token:', err);
        this._msgService.error({
          title: 'Session Error',
          message: 'There was an error while refreshing your session. Please try again later.'
        });
      }
    );
  }

  private startCountdown() {
    if (this.counterSubscription == null || this.counterSubscription.closed) {
      const titleMessage = 'Attention! Timeout warning';
      this.remainingCount = this.count;
      this.counterSubscription = interval(1000).subscribe(cnt => {
        document.title = document.title === titleMessage ? this.originalTitle : titleMessage;
        this.remainingCount = this.count - cnt;
        if (this.remainingCount <= 0) {
          document.title = this.originalTitle;
          this.dialog.closeAll();
          if (this.counterSubscription) {
            this.counterSubscription.unsubscribe();
          }
          if (this.timer) {
            this.timer.unsubscribe(); // Stop the timer when the component is destroyed
          }
          this.showSessionExpirationMessage();
        }
      });
    }
  }
}
